const state = () => ({
  visitedRoutes: [],
})
const getters = {
  visitedRoutes: (state) => state.visitedRoutes,
}
const mutations = {
  addVisitedRoute(state, route) {
    let index = state.visitedRoutes.findIndex(
      (item) => item.path === route.path
    )
    let target
    if (index > -1) {
      if (route.path === '/index') return
      target = state.visitedRoutes.splice(index, 1)[0]
      if (route.fullPath !== target.fullPath) Object.assign(target, route)
    } else {
      target = Object.assign({}, route)
    }
    state.visitedRoutes.push(target)
  },
  delVisitedRoute(state, route) {
    state.visitedRoutes.forEach((item, index) => {
      if (item.path === route.path) state.visitedRoutes.splice(index, 1)
    })
  },
  delOthersVisitedRoute(state, route) {
    state.visitedRoutes = state.visitedRoutes.filter(
      (item) => item.meta.affix || item.path === route.path
    )
  },
  delAllVisitedRoutes(state) {
    state.visitedRoutes = state.visitedRoutes.filter((item) => item.meta.affix)
  },
}
const actions = {
  addVisitedRoute({ commit }, route) {
    commit('addVisitedRoute', route)
  },
  async delVisitedRoute({ commit, state }, route) {
    await commit('delVisitedRoute', route)
    // console.log(JSON.parse(JSON.stringify(state.visitedRoutes)))
    return [...state.visitedRoutes]
  },
  async delOthersRoutes({ dispatch, state }, route) {
    await dispatch('delOthersVisitedRoute', route)
    return {
      visitedRoutes: [...state.visitedRoutes],
    }
  },
  delAllVisitedRoutes({ commit, state }) {
    commit('delAllVisitedRoutes')
    return [...state.visitedRoutes]
  },
}
export default { state, getters, mutations, actions }
